<template>
  <div v-if="!hideWhenNoCompanyLogo || logoExists" class="text-center">
    <div v-if="logoExists">
      <img :src="logoUrl" />  
      <br/>
      <br/>
      <small class="text-uppercase font-weight-bold">Powered by</small>
      <br/>
    </div>
    <img alt="SmoothTeam" src="../assets/logo.png" :style="getStyle" />
    <br/>
    <br/>
  </div>
</template>

<script>
export default {
  props: {
    hideWhenNoCompanyLogo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logoExists() {
      return this.$store.state.main.userCompanyLogo !== null ||
        this.$store.state.main.game.companyLogo !== null;
    },
    logoUrl() {
      if (this.$store.state.main.game.companyLogo !== null) {
        return this.$store.state.main.game.companyLogo;
      }

      if (this.$store.state.main.userCompanyLogo !== null) {
        return this.$store.state.main.userCompanyLogo;
      }

      return "";
    },
    getStyle() {
      if (!this.logoExists) {
        return "";
      } else {
        return "height:20px;";
      }
    },
  },
};
</script>
